module.exports = __webpack_public_path__ + "static/img/Charlie-Curnow.74779c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Curnow.jpg
// module id = h2K3
// module chunks = 0